import { jsx as t, jsxs as i, Fragment as B } from "react/jsx-runtime";
import { forwardRef as W } from "react";
import { D as z } from "../index-D6IbTb4M.js";
import { c as o } from "../clsx-OuTLNxxd.js";
import { A as S, a as k } from "../Avatar-DjiAoB1w.js";
import { B as L } from "../Button-DIvSLTPg.js";
import '../OddsButton.css';const O = "320px", w = "600px", C = "1025px", N = "_oddsButton_n321a_32", v = "_oddsContainer_n321a_45", D = "_line_n321a_45", I = "_odds_n321a_32", M = "_lockedIcon_n321a_62", A = "_withLine_n321a_90", j = "_oddsButtonWrapper_n321a_127", $ = "_shouldHideLabelOnMobile_n321a_138", F = "_shouldHideLabelOnDesktop_n321a_151", e = {
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  mobile: O,
  "mobile-wide": "480px",
  tablet: w,
  "tablet-wide": "800px",
  desktop: C,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  oddsButton: N,
  oddsContainer: v,
  line: D,
  odds: I,
  lockedIcon: M,
  withLine: A,
  "direction-row": "_direction-row_n321a_108",
  oddsButtonWrapper: j,
  shouldHideLabelOnMobile: $,
  shouldHideLabelOnDesktop: F
}, R = W(
  ({
    bookieColour: a,
    bookieLogo: h,
    bookieName: s,
    className: r = "",
    flexDirection: y = "column",
    hideBookieLogo: m = !1,
    label: l,
    line: n,
    locked: g = !1,
    odds: f,
    selected: d,
    shouldHideLabelOnDesktop: b = !1,
    shouldHideLabelOnMobile: u = !1,
    wrapperClassName: p = "",
    wrapperStyles: H = {},
    ...x
  }, _) => {
    const c = /* @__PURE__ */ t(
      L,
      {
        className: o(e.oddsButton, r),
        disabled: x.disabled,
        ref: _,
        variant: d ? "secondary" : "default",
        ...x,
        pressed: d,
        title: s,
        children: g ? /* @__PURE__ */ t(z, { className: e.lockedIcon }) : /* @__PURE__ */ i(B, { children: [
          !m && /* @__PURE__ */ t(S, { size: "small", style: { backgroundColor: a }, children: /* @__PURE__ */ t(k, { alt: `${s} logo`, src: h }) }),
          /* @__PURE__ */ i("div", { className: o(e.oddsContainer, e[`direction-${y}`]), children: [
            n && /* @__PURE__ */ t("span", { className: e.line, children: n }),
            /* @__PURE__ */ t("span", { className: o(e.odds, { [e.withLine]: n }), children: f })
          ] })
        ] })
      }
    );
    return l ? /* @__PURE__ */ i(
      "div",
      {
        className: o(
          e.oddsButtonWrapper,
          {
            [e.shouldHideLabelOnDesktop]: b,
            [e.shouldHideLabelOnMobile]: u
          },
          p
        ),
        "data-cxy-name": "odds-button",
        style: H,
        children: [
          /* @__PURE__ */ t("p", { children: l }),
          c
        ]
      }
    ) : c;
  }
);
R.displayName = "OddsButton";
export {
  R as OddsButton
};
